import Palette from './Palette';

export const positiveOrNeutralTextColor = (val: number) => (val === 0 ? Palette.Text.x30 : Palette.Text.x10);
